import { render } from "./k-confirm-close.vue?vue&type=template&id=24a85ae8"
import script from "./k-confirm-close.vue?vue&type=script&lang=js"
export * from "./k-confirm-close.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__